import { useState } from 'react';
import { Link, NavLink } from "react-router-dom";
import { svgs } from '../assets/svgs';
import { tracking } from '../utils/tracking';

const pages = [
   { name: 'startups', link: 'startups', trackingId: 251, },
   { name: 'speakers', link: 'speakers', trackingId: 252, },
   { name: 'agenda', link: 'agenda', trackingId: 253, },
   { name: 'partners', link: 'partners', trackingId: 254, },
   // { name: 'venue', link: 'venue', trackingId: 255, },
]

export const NavBar = () => {
   const [isMenuOpen, setIsMenuOpen] = useState(false)

   return (
      <div className='nav-bar'>

         <section className='logo-section' >
            <Link onClick={() => setIsMenuOpen(false)} to='/'>{svgs.eventLogo}</Link>
            <div className='logo-venue'>
               <h6>Javits Center, NYC</h6>
               <h6>Sept 6 & 7, 2023</h6>
            </div>
         </section>
         <section className={isMenuOpen ? 'nav open' : 'nav'}>
            {
               pages.map(page =>
                  <NavLink onClick={() => { setIsMenuOpen(false); tracking(page.trackingId) }} className='link' key={page.name} to={page.link}>{page.name}</NavLink>
               )
            }
            {/* <div className='btns mobile'>
               <Link onClick={() => { setIsMenuOpen(false); tracking(256) }} className='btn' to={'registration'}>Tickets</Link>
               <Link onClick={() => { setIsMenuOpen(false); tracking(257) }} className='btn' to={'startups'}>Present</Link>
            </div> */}
         </section>
         <section className='btns desktop'>
            {/* <Link onClick={() => { setIsMenuOpen(false); tracking(256) }} className='btn' to={'registration'}>Tickets</Link>
            <Link onClick={() => { setIsMenuOpen(false); tracking(257) }} className='btn' to={'startups'}>Present</Link> */}
         </section>
         <section className='hamburger-section'>
            <button onClick={() => setIsMenuOpen(prev => !prev)}>
               {isMenuOpen ? svgs.clear : svgs.hamburger}
            </button>
         </section>

      </div >
   )
}





